import { render, staticRenderFns } from "./TransactionInformation.vue?vue&type=template&id=1f4d9a2d&scoped=true"
import script from "./TransactionInformation.vue?vue&type=script&lang=js"
export * from "./TransactionInformation.vue?vue&type=script&lang=js"
import style0 from "./TransactionInformation.vue?vue&type=style&index=0&id=1f4d9a2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4d9a2d",
  null
  
)

export default component.exports